import { render } from "./ViewApprovedRequirementsDialog.vue?vue&type=template&id=05889217&scoped=true"
import script from "./ViewApprovedRequirementsDialog.vue?vue&type=script&lang=js"
export * from "./ViewApprovedRequirementsDialog.vue?vue&type=script&lang=js"

import "./ViewApprovedRequirementsDialog.vue?vue&type=style&index=0&id=05889217&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05889217"]])

export default __exports__